import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from '../../api/apiClient';
import {token, domain} from '../Security';
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import loadingSpinner from './../../assets/loading.gif';
//icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Alphalist({user, isHideSideMenu}) {
    const [companyId, setCompanyId] = useState(0);
    const [company, setCompany] = useState(null);
    const [classificationId, setClassificationId] = useState(0);
    const [departmentId, setDepartmentId] = useState(0);
    const [locationId, setLocationId] = useState(0);
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const numberWithCommasAndDecimal = (number) => {
        if(!number){
            return "0.00";
        }
        return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    const writeFont8Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 8, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }

    const modifyAndDownloadPDF = useCallback(async (data) => {
        if (data.length <= 0) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No records found");
            return;
        }

        setLoading(true);
        console.log(data)

        try {
            // Load the existing PDF template
            const pdfUrl = `${window.location.origin}/docs/Alphalist.pdf`;
            const response = await fetch(pdfUrl);
            const pdfBytes = await response.arrayBuffer();
            const basePdfDoc = await PDFDocument.load(pdfBytes);

            const pdfDoc = await PDFDocument.create();
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

            //1080 height

            const lineSpacing = 17.2;
            const minY = 0; // Prevents writing too low
            let startY = 987;

            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [firstPage] = await pdfDoc.copyPages(basePdfDoc, [0]);
            pdfDoc.addPage(firstPage); // ✅ Step 1: Add Page 1 first

            let page_first = pdfDoc.getPages()[0]; // Start writing to the first page
            let pageCount_first = 1;
            writeFont8Black({ page: page_first, font, x: 725, y: 5, text: `7.1 Page ${pageCount_first}` });

            for (let index = 0; index < data.Resigned.length; index++) {
                const item = data.Resigned[index];

                const startX_item_1 = 28;
                const startX_item_2 = 65;
                const startX_item_3 = 155;
                const startX_item_4 = 217.5;
                const startX_item_5 = 292.5;
                const startX_item_6 = 360;
                const startX_item_7 = 412.5;
                const startX_item_8 = 462.5;
                const startX_item_9 = 552.5;
                const startX_item_10 = 660;
                const startX_item_11 = 730;
                const startX_item_12 = 875;
                const startX_item_13 = 990;
                const startX_item_14 = 1127.5;
                const startX_item_15 = 1215;
                const startX_item_16 = 1350;
                const startX_item_17 = 1465;

                if (startY - lineSpacing < minY) {
                    pageCount_first += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [0]);
                    page_first = pdfDoc.addPage(templatePage);
                    startY = 987;
                    writeFont8Black({ page: page_first, font, x: 725, y: 5, text: `7.1 Page ${pageCount_first}` });
                }

                writeFont8Black({ page: page_first, font, x: startX_item_1, y: startY, text: `${index + 1}` });
                writeFont8Black({ page: page_first, font, x: startX_item_2, y: startY, text: `${item.tin ?? ""}` });
                writeFont8Black({ page: page_first, font, x: startX_item_3, y: startY, text: `${item.lastName ?? ""}` });
                writeFont8Black({ page: page_first, font, x: startX_item_4, y: startY, text: `${item.firstName ?? ""}` });
                writeFont8Black({ page: page_first, font, x: startX_item_5, y: startY, text: `${item.middleName ?? ""}` });

                const dateEmployed = item.dateEmployed?.split("T")[0];
                const dateResigned = item.dateResigned?.split("T")[0];

                writeFont8Black({ page: page_first, font, x: startX_item_6, y: startY, text: `${dateEmployed ?? ""}` });
                writeFont8Black({ page: page_first, font, x: startX_item_7, y: startY, text: `${dateResigned ?? ""}` });
                writeFont8Black({ page: page_first, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(item.grossIncome)}` });
                writeFont8Black({ page: page_first, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_first, font, x: startX_item_10, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.deMinimisBenefits)}` });
                writeFont8Black({ page: page_first, font, x: startX_item_11, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.contributions)}` });
                writeFont8Black({ page: page_first, font, x: startX_item_12, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_first, font, x: startX_item_13, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.total)}` });
                writeFont8Black({ page: page_first, font, x: startX_item_14, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.basicSalary)}` });
                writeFont8Black({ page: page_first, font, x: startX_item_15, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_first, font, x: startX_item_16, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_first, font, x: startX_item_17, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.total)}` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            
            
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [secondPage] = await pdfDoc.copyPages(basePdfDoc, [1]);
            pdfDoc.addPage(secondPage);

            let page_second = pdfDoc.getPages()[pageCount_first];
            let pageCount_second = 1;
            writeFont8Black({ page: page_second, font, x: 725, y: 5, text: `7.1 (continuation) Page ${pageCount_second}` });

            startY = 987

            for (let index = 0; index < data.Resigned.length; index++) {
                const item = data.Resigned[index];

                const startX_item_1 = 15;
                const startX_item_2 = 110;
                const startX_item_3 = 275;
                const startX_item_4 = 410;
                const startX_item_5 = 510;
                const startX_item_6 = 705;
                const startX_item_7 = 860;
                const startX_item_8 = 1095;
                const startX_item_9 = 1260;
                const startX_item_10 = 1465;

                if (startY - lineSpacing < minY) {
                    pageCount_second += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [1]);
                    page_second = pdfDoc.addPage(templatePage);
                    startY = 987;
                    writeFont8Black({ page: page_second, font, x: 725, y: 5, text: `7.1 (continuation) Page ${pageCount_second}` });
                }

                writeFont8Black({ page: page_second, font, x: startX_item_1, y: startY, text: `${item.exemption?.code ?? ""}` });
                writeFont8Black({ page: page_second, font, x: startX_item_2, y: startY, text: `${numberWithCommasAndDecimal(item.exemption?.amount)}` });
                writeFont8Black({ page: page_second, font, x: startX_item_3, y: startY, text: `${numberWithCommasAndDecimal(item.premiumPaidOnHealth)}` });
                writeFont8Black({ page: page_second, font, x: startX_item_4, y: startY, text: `${numberWithCommasAndDecimal(item.netTaxableIncome)}` });
                writeFont8Black({ page: page_second, font, x: startX_item_5, y: startY, text: `${numberWithCommasAndDecimal(item.taxDue)}` });
                writeFont8Black({ page: page_second, font, x: startX_item_6, y: startY, text: `${numberWithCommasAndDecimal(item.taxWithheld)}` });
                writeFont8Black({ page: page_second, font, x: startX_item_7, y: startY, text: `${numberWithCommasAndDecimal(item.yearEndAdjutment.amountWithheld)}` });
                writeFont8Black({ page: page_second, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(item.yearEndAdjutment.overWithheld)}` });
                writeFont8Black({ page: page_second, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(item.amountOfTaxWithheldAsAdjusted)}` });
                writeFont8Black({ page: page_second, font, x: startX_item_10, y: startY, text: `${item.substitutedFilling ? "Yes" : "No"}` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////

            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [thirdPage] = await pdfDoc.copyPages(basePdfDoc, [2]);
            pdfDoc.addPage(thirdPage);

            let page_third = pdfDoc.getPages()[pageCount_first + pageCount_second];
            let pageCount_third = 1;
            writeFont8Black({ page: page_third, font, x: 725, y: 5, text: `7.2 Page ${pageCount_third}` });

            startY = 987

            for (let index = 0; index < data.NonTaxable.length; index++) {
                const item = data.NonTaxable[index];

                const startX_item_1 = 20;
                const startX_item_2 = 50;
                const startX_item_3 = 140;
                const startX_item_4 = 200;
                const startX_item_5 = 265;
                const startX_item_6 = 332.5;
                const startX_item_7 = 432.5;
                const startX_item_8 = 512.5;
                const startX_item_9 = 580;
                const startX_item_10 = 725;
                const startX_item_11 = 840;
                const startX_item_12 = 970;
                const startX_item_13 = 1055.5;
                const startX_item_14 = 1172.5;
                const startX_item_15 = 1260;
                const startX_item_16 = 1375;
                const startX_item_17 = 1450;
                const startX_item_18 = 1525;

                if (startY - lineSpacing < minY) {
                    pageCount_third += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [2]);
                    page_third = pdfDoc.addPage(templatePage);
                    startY = 987;
                    writeFont8Black({ page: page_third, font, x: 725, y: 5, text: `7.2 Page ${pageCount_third}` });
                }

                writeFont8Black({ page: page_third, font, x: startX_item_1, y: startY, text: `${index + 1}` });
                writeFont8Black({ page: page_third, font, x: startX_item_2, y: startY, text: `${item.tin ?? ""}` });
                writeFont8Black({ page: page_third, font, x: startX_item_3, y: startY, text: `${item.lastName ?? ""}` });
                writeFont8Black({ page: page_third, font, x: startX_item_4, y: startY, text: `${item.firstName ?? ""}` });
                writeFont8Black({ page: page_third, font, x: startX_item_5, y: startY, text: `${item.middleName ?? ""}` });
                writeFont8Black({ page: page_third, font, x: startX_item_6, y: startY, text: `${numberWithCommasAndDecimal(item.grossIncome)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_7, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.deMinimisBenefits)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.contributions)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_10, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_11, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.total)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_12, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.basicSalary)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_13, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_14, y: startY, text: `${item.exemption.code ?? ""}` });
                writeFont8Black({ page: page_third, font, x: startX_item_15, y: startY, text: `${numberWithCommasAndDecimal(item.exemption.amount)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_16, y: startY, text: `${numberWithCommasAndDecimal(item.premiumPaidOnHealth)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_17, y: startY, text: `${numberWithCommasAndDecimal(item.netTaxableIncome)}` });
                writeFont8Black({ page: page_third, font, x: startX_item_18, y: startY, text: `${numberWithCommasAndDecimal(item.taxDue)}` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////

            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [fourthPage] = await pdfDoc.copyPages(basePdfDoc, [3]);
            pdfDoc.addPage(fourthPage);

            let page_fourth = pdfDoc.getPages()[pageCount_first + pageCount_second + pageCount_third];
            let pageCount_fourth = 1;
            writeFont8Black({ page: page_fourth, font, x: 725, y: 5, text: `7.3 Page ${pageCount_fourth}` });

            startY = 977

            for (let index = 0; index < data.NoPreviousEmployer.length; index++) {
                const item = data.NoPreviousEmployer[index];

                const startX_item_1 = 20;
                const startX_item_2 = 50;
                const startX_item_3 = 140;
                const startX_item_4 = 200;
                const startX_item_5 = 265;
                const startX_item_6 = 332.5;
                const startX_item_7 = 435;
                const startX_item_8 = 540;
                const startX_item_9 = 660;
                const startX_item_10 = 805;
                const startX_item_11 = 955;
                const startX_item_12 = 1120;
                const startX_item_13 = 1205;
                const startX_item_14 = 1310;
                const startX_item_15 = 1475;

                if (startY - lineSpacing < minY) {
                    pageCount_fourth += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [3]);
                    page_fourth = pdfDoc.addPage(templatePage);
                    startY = 977;
                    writeFont8Black({ page: page_fourth, font, x: 725, y: 5, text: `7.3 Page ${pageCount_fourth}` });
                }

                writeFont8Black({ page: page_fourth, font, x: startX_item_1, y: startY, text: `${index + 1}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_2, y: startY, text: `${item.tin ?? ""}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_3, y: startY, text: `${item.lastName ?? ""}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_4, y: startY, text: `${item.firstName ?? ""}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_5, y: startY, text: `${item.middleName ?? ""}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_6, y: startY, text: `${numberWithCommasAndDecimal(item.grossIncome)}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_7, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.deMinimisBenefits)}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.contributions)}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_10, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_11, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.total)}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_12, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.basicSalary)}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_13, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_14, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_fourth, font, x: startX_item_15, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.total)}` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////

            

            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [fifthPage] = await pdfDoc.copyPages(basePdfDoc, [4]);
            pdfDoc.addPage(fifthPage);

            let page_fifth = pdfDoc.getPages()[pageCount_first + pageCount_second + pageCount_third + pageCount_fourth];
            let pageCount_fifth = 1;
            writeFont8Black({ page: page_fifth, font, x: 725, y: 5, text: `7.3 (continuation) Page ${pageCount_fifth}` });

            startY = 987

            for (let index = 0; index < data.NoPreviousEmployer.length; index++) {
                const item = data.NoPreviousEmployer[index];

                const startX_item_1 = 10;
                const startX_item_2 = 105;
                const startX_item_3 = 235;
                const startX_item_4 = 372.5;
                const startX_item_5 = 472.5;
                const startX_item_6 = 665;
                const startX_item_7 = 825;
                const startX_item_8 = 1055;
                const startX_item_9 = 1255;
                const startX_item_10 = 1460;

                if (startY - lineSpacing < minY) {
                    pageCount_fifth += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [4]);
                    page_fifth = pdfDoc.addPage(templatePage);
                    startY = 987;
                    writeFont8Black({ page: page_fifth, font, x: 725, y: 5, text: `7.3 (continuation) Page ${pageCount_fifth}` });
                }

                writeFont8Black({ page: page_fifth, font, x: startX_item_1, y: startY, text: `${item.exemption?.code ?? ""}` });
                writeFont8Black({ page: page_fifth, font, x: startX_item_2, y: startY, text: `${numberWithCommasAndDecimal(item.exemption.amount)}` });
                writeFont8Black({ page: page_fifth, font, x: startX_item_3, y: startY, text: `${numberWithCommasAndDecimal(item.premiumPaidOnHealth)}` });
                writeFont8Black({ page: page_fifth, font, x: startX_item_4, y: startY, text: `${numberWithCommasAndDecimal(item.netTaxableIncome)}` });
                writeFont8Black({ page: page_fifth, font, x: startX_item_5, y: startY, text: `${numberWithCommasAndDecimal(item.taxDue)}` });
                writeFont8Black({ page: page_fifth, font, x: startX_item_6, y: startY, text: `${numberWithCommasAndDecimal(item.taxWithheld)}` });
                writeFont8Black({ page: page_fifth, font, x: startX_item_7, y: startY, text: `${numberWithCommasAndDecimal(item.yearEndAdjutment.amountWithheld)}` });
                writeFont8Black({ page: page_fifth, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(item.yearEndAdjutment.overWithheld)}` });
                writeFont8Black({ page: page_fifth, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(item.amountOfTaxWithheldAsAdjusted)}` });
                writeFont8Black({ page: page_fifth, font, x: startX_item_10, y: startY, text: `${item.substitutedFilling ? "Yes" : "No"}` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////

            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [sixthPage] = await pdfDoc.copyPages(basePdfDoc, [5]);
            pdfDoc.addPage(sixthPage);

            let page_sixth = pdfDoc.getPages()[pageCount_first + pageCount_second + pageCount_third + pageCount_fourth + pageCount_fifth];
            let pageCount_sixth = 1;
            writeFont8Black({ page: page_sixth, font, x: 725, y: 5, text: `7.4 Page ${pageCount_sixth}` });

            startY = 935

            for (let index = 0; index < data.WithPreviousEmployer?.length; index++) {
                const item = data.WithPreviousEmployer[index];

                const startX_item_1 = 20;
                const startX_item_2 = 50;
                const startX_item_3 = 140;
                const startX_item_4 = 205;
                const startX_item_5 = 270;
                const startX_item_6 = 337.5;
                const startX_item_7 = 430;
                const startX_item_8 = 535;
                const startX_item_9 = 605;
                const startX_item_10 = 700;
                const startX_item_11 = 787.5;
                const startX_item_12 = 887.5;
                const startX_item_13 = 975;
                const startX_item_14 = 1080;
                const startX_item_15 = 1160;
                const startX_item_16 = 1230;
                const startX_item_17 = 1300;
                const startX_item_18 = 1367.5;
                const startX_item_19 = 1437.5;
                const startX_item_20 = 1510;

                if (startY - lineSpacing < minY) {
                    pageCount_sixth += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [5]);
                    page_sixth = pdfDoc.addPage(templatePage);
                    startY = 935;
                    writeFont8Black({ page: page_sixth, font, x: 725, y: 5, text: `7.4 Page ${pageCount_sixth}` });
                }

                writeFont8Black({ page: page_sixth, font, x: startX_item_1, y: startY, text: `${index + 1}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_2, y: startY, text: `${item.tin ?? ""}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_3, y: startY, text: `${item.lastName ?? ""}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_4, y: startY, text: `${item.firstName ?? ""}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_5, y: startY, text: `${item.middleName ?? ""}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_6, y: startY, text: `${numberWithCommasAndDecimal(item.grossIncome)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_7, y: startY, text: `${numberWithCommasAndDecimal(item.previousEmployer.nonTaxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(item.previousEmployer.nonTaxable.deMinimisBenefits)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(item.previousEmployer.nonTaxable.contributions)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_10, y: startY, text: `${numberWithCommasAndDecimal(item.previousEmployer.nonTaxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_11, y: startY, text: `${numberWithCommasAndDecimal(item.previousEmployer.nonTaxable.total)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_12, y: startY, text: `${numberWithCommasAndDecimal(item.previousEmployer.taxable.basicSalary)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_13, y: startY, text: `${numberWithCommasAndDecimal(item.previousEmployer.taxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_14, y: startY, text: `${numberWithCommasAndDecimal(item.previousEmployer.taxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_15, y: startY, text: `${numberWithCommasAndDecimal(item.previousEmployer.taxable.total)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_16, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_17, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.deMinimisBenefits)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_18, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.contributions)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_19, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_sixth, font, x: startX_item_20, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.total)}` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////

            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [seventhPage] = await pdfDoc.copyPages(basePdfDoc, [6]);
            pdfDoc.addPage(seventhPage);

            let page_seventh = pdfDoc.getPages()[pageCount_first + pageCount_second + pageCount_third + pageCount_fourth + pageCount_fifth + pageCount_sixth];
            let pageCount_seventh = 1;
            writeFont8Black({ page: page_seventh, font, x: 725, y: 5, text: `7.4 (continuation) Page ${pageCount_seventh}` });

            startY = 987

            for (let index = 0; index < data.WithPreviousEmployer?.length; index++) {
                const item = data.WithPreviousEmployer[index];

                const startX_item_1 = 10;
                const startX_item_2 = 60;
                const startX_item_3 = 155;
                const startX_item_4 = 235;
                const startX_item_5 = 325;
                const startX_item_6 = 450;
                const startX_item_7 = 545;
                const startX_item_8 = 710;
                const startX_item_9 = 847.5;
                const startX_item_10 = 947.5;
                const startX_item_11 = 1037.5;
                const startX_item_12 = 1127.5;
                const startX_item_13 = 1210;
                const startX_item_14 = 1330;
                const startX_item_15 = 1457.5;

                if (startY - lineSpacing < minY) {
                    pageCount_seventh += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [6]);
                    page_seventh = pdfDoc.addPage(templatePage);
                    startY = 987;
                    writeFont8Black({ page: page_seventh, font, x: 725, y: 5, text: `7.4 (continuation) Page ${pageCount_seventh}` });
                }
                
                writeFont8Black({ page: page_seventh, font, x: startX_item_1, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.basicSalary)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_2, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_3, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_4, y: startY, text: `0.00` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_5, y: startY, text: `0.00` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_6, y: startY, text: `${item.exemption?.code ?? ""}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_7, y: startY, text: `${numberWithCommasAndDecimal(item.exemption.amount)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(item.premiumPaidOnHealth)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(item.netTaxableIncome)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_10, y: startY, text: `${numberWithCommasAndDecimal(item.taxDue)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_11, y: startY, text: `${numberWithCommasAndDecimal(item.taxWithheld)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_12, y: startY, text: `${numberWithCommasAndDecimal(item.yearEndAdjutment.amountWithheld)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_13, y: startY, text: `${numberWithCommasAndDecimal(item.yearEndAdjutment.overWithheld)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_14, y: startY, text: `${numberWithCommasAndDecimal(item.amountOfTaxWithheldAsAdjusted)}` });
                writeFont8Black({ page: page_seventh, font, x: startX_item_15, y: startY, text: `0.00` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////

            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [eighthPage] = await pdfDoc.copyPages(basePdfDoc, [7]);
            pdfDoc.addPage(eighthPage);

            let page_eighth = pdfDoc.getPages()[pageCount_first + pageCount_second + pageCount_third + pageCount_fourth + pageCount_fifth + pageCount_sixth + pageCount_seventh];
            let pageCount_eighth  = 1;
            writeFont8Black({ page: page_eighth, font, x: 725, y: 5, text: `7.5 Page ${pageCount_eighth}` });

            startY = 935

            for (let index = 0; index < data.MWE.length; index++) {
                const item = data.MWE[index];

                const startX_item_1 = 20;
                const startX_item_2 = 47.5;
                const startX_item_3 = 135;
                const startX_item_4 = 190;
                const startX_item_5 = 275;
                const startX_item_6 = 328;
                const startX_item_7 = 380;
                const startX_item_8 = 465;
                const startX_item_9 = 530;
                const startX_item_10 = 600;
                const startX_item_11 = 675;
                const startX_item_12 = 750;
                const startX_item_13 = 825;
                const startX_item_14 = 927.5;
                const startX_item_15 = 992.5;
                const startX_item_16 = 1087.5;
                const startX_item_17 = 1175;
                const startX_item_18 = 1272;
                const startX_item_19 = 1362.5;
                const startX_item_20 = 1477.5;

                if (startY - lineSpacing < minY) {
                    pageCount_eighth += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [7]);
                    page_eighth = pdfDoc.addPage(templatePage);
                    startY = 935;
                    writeFont8Black({ page: page_eighth, font, x: 725, y: 5, text: `7.5 Page ${pageCount_eighth}` });
                }

                writeFont8Black({ page: page_eighth, font, x: startX_item_1, y: startY, text: `${index + 1}` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_2, y: startY, text: `${item.tin ?? ""}` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_3, y: startY, text: `${item.lastName ?? ""}` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_4, y: startY, text: `${item.firstName ?? ""}` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_5, y: startY, text: `${item.middleName ?? ""}` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_6, y: startY, text: `${""}` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_7, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_8, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_9, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_10, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_11, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_12, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_13, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_14, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_15, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_16, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_17, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_18, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_19, y: startY, text: `0.00` });
                writeFont8Black({ page: page_eighth, font, x: startX_item_20, y: startY, text: `0.00` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////

            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [ninethPage] = await pdfDoc.copyPages(basePdfDoc, [8]);
            pdfDoc.addPage(ninethPage);

            let page_nineth = pdfDoc.getPages()[pageCount_first 
                                            + pageCount_second 
                                            + pageCount_third 
                                            + pageCount_fourth 
                                            + pageCount_fifth 
                                            + pageCount_sixth 
                                            + pageCount_seventh 
                                            + pageCount_eighth];
            let pageCount_nineth  = 1;
            writeFont8Black({ page: page_nineth, font, x: 725, y: 5, text: `7.5 (continuation 1) Page ${pageCount_nineth}` });

            startY = 935

            for (let index = 0; index < data.MWE.length; index++) {
                const item = data.MWE[index];

                const startX_item_1 = 6;
                const startX_item_2 = 50;
                const startX_item_3 = 102.5;
                const startX_item_4 = 195;
                const startX_item_5 = 270;
                const startX_item_6 = 347.5;
                const startX_item_7 = 425;
                const startX_item_8 = 490;
                const startX_item_9 = 561;
                const startX_item_10 = 630;
                const startX_item_11 = 707;
                const startX_item_12 = 782.5;
                const startX_item_13 = 895;
                const startX_item_14 = 961;
                const startX_item_15 = 1050;
                const startX_item_16 = 1140;
                const startX_item_17 = 1245;
                const startX_item_18 = 1332.5;
                const startX_item_19 = 1445;

                if (startY - lineSpacing < minY) {
                    pageCount_nineth += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [8]);
                    page_nineth = pdfDoc.addPage(templatePage);
                    startY = 935;
                    writeFont8Black({ page: page_nineth, font, x: 725, y: 5, text: `7.5 (continuation 1) Page ${pageCount_nineth}` });
                }

                const dateEmployed = item.dateEmployed?.split("T")[0];
                const dateResigned = item.dateResigned?.split("T")[0];

                writeFont8Black({ page: page_nineth, font, x: startX_item_1, y: startY, text: `${dateEmployed ?? ""}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_2, y: startY, text: `${dateResigned ?? ""}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_3, y: startY, text: `${numberWithCommasAndDecimal(item.grossIncome)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_4, y: startY, text: `${numberWithCommasAndDecimal(0)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_5, y: startY, text: `${numberWithCommasAndDecimal(0)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_6, y: startY, text: `${numberWithCommasAndDecimal(0)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_7, y: startY, text: `${numberWithCommasAndDecimal(0)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(item.holidayPay)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(item.otPay)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_10, y: startY, text: `${numberWithCommasAndDecimal(item.nightShiftPay)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_11, y: startY, text: `${numberWithCommasAndDecimal(0)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_12, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_13, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.deMinimisBenefits)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_14, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.contributions)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_15, y: startY, text: `${numberWithCommasAndDecimal(item.nonTaxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_16, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.thirteenthMonthPay)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_17, y: startY, text: `${numberWithCommasAndDecimal(item.taxable.salariesOrOtherFormsOfCompensation)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_18, y: startY, text: `${numberWithCommasAndDecimal(0)}` });
                writeFont8Black({ page: page_nineth, font, x: startX_item_19, y: startY, text: `${numberWithCommasAndDecimal(0)}` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////

            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            const [tenthPage] = await pdfDoc.copyPages(basePdfDoc, [9]);
            pdfDoc.addPage(tenthPage);

            let page_tenth = pdfDoc.getPages()[pageCount_first 
                                            + pageCount_second 
                                            + pageCount_third 
                                            + pageCount_fourth 
                                            + pageCount_fifth 
                                            + pageCount_sixth 
                                            + pageCount_seventh 
                                            + pageCount_eighth
                                            + pageCount_nineth];
            let pageCount_tenth  = 1;
            writeFont8Black({ page: page_tenth, font, x: 725, y: 5, text: `7.5 (continuation 2) Page ${pageCount_tenth}` });

            startY = 935

            for (let index = 0; index < data.MWE.length; index++) {
                const item = data.MWE[index];

                const startX_item_1 = 7.5;
                const startX_item_2 = 105;
                const startX_item_3 = 235;
                const startX_item_4 = 370;
                const startX_item_5 = 467.5;
                const startX_item_6 = 610;
                const startX_item_7 = 793;
                const startX_item_8 = 935;
                const startX_item_9 = 1142.5;
                const startX_item_10 = 1330;

                if (startY - lineSpacing < minY) {
                    pageCount_tenth += 1;
                    const [templatePage] = await pdfDoc.copyPages(basePdfDoc, [9]);
                    page_tenth = pdfDoc.addPage(templatePage);
                    startY = 935;
                    writeFont8Black({ page: page_tenth, font, x: 725, y: 5, text: `7.5 (continuation 2) Page ${pageCount_tenth}` });
                }

                writeFont8Black({ page: page_tenth, font, x: startX_item_1, y: startY, text: `${item.exemption?.code ?? ""}` });
                writeFont8Black({ page: page_tenth, font, x: startX_item_2, y: startY, text: `${numberWithCommasAndDecimal(item.exemption.amount)}` });
                writeFont8Black({ page: page_tenth, font, x: startX_item_3, y: startY, text: `${numberWithCommasAndDecimal(item.premiumPaidOnHealth)}` });
                writeFont8Black({ page: page_tenth, font, x: startX_item_4, y: startY, text: `${numberWithCommasAndDecimal(item.netTaxableIncome)}` });
                writeFont8Black({ page: page_tenth, font, x: startX_item_5, y: startY, text: `${numberWithCommasAndDecimal(item.taxDue)}` });
                writeFont8Black({ page: page_tenth, font, x: startX_item_6, y: startY, text: `0.00` });
                writeFont8Black({ page: page_tenth, font, x: startX_item_7, y: startY, text: `0.00` });
                writeFont8Black({ page: page_tenth, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(item.yearEndAdjutment.amountWithheld)}` });
                writeFont8Black({ page: page_tenth, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(item.yearEndAdjutment.overWithheld)}` });
                writeFont8Black({ page: page_tenth, font, x: startX_item_10, y: startY, text: `${numberWithCommasAndDecimal(item.amountOfTaxWithheldAsAdjusted)}` });

                startY -= lineSpacing; // Move to next row
            }
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////

            setShowRequestMessage(true);
            setIsSuccess(true);

            setLoading(false);

            // Save and Download PDF
            const modifiedPdfBytes = await pdfDoc.save();
            const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });

            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `Alphalist.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(a.href);
        } catch (error) {
            setLoading(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error("Error:", error);
            setRequestMessage("Error processing PDF");
        }
    }, []);

    const fetchDataCompany = useCallback(async () => {
        const apiUrl =  domain + `/api/Company/${companyId}`;

        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return response.data;
        } catch (error) {
            return null
        }
    }, [companyId]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/alphalist/classification/${classificationId}/department/${departmentId}/location/${locationId}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            const _company = await fetchDataCompany();
            setCompany(_company)

            modifyAndDownloadPDF(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [fetchDataCompany, modifyAndDownloadPDF, classificationId, departmentId, locationId]);

    const generate = () =>{
        if(!company
            || !classificationId
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo shadow-xl">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Alphalist"}</span>
                            </div>
                            <h3>Generate Alphalist Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row" style={{alignItems: "center", justifyContent: "normal"}}>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect companyId={companyId} setCompanyId={setCompanyId} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !companyId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Classification</div>
                                    <div className="info-item-input">
                                        <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                                    </div>
                                    <span style={{
                                                visibility: !classificationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Department</div>
                                    <div className="info-item-input">
                                        <DepartmentIdSelect departmentId={departmentId} setDepartmentId={setDepartmentId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="info-item-holder row" style={{justifyContent: "normal"}}>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Location</div>
                                    <div className="info-item-input">
                                        <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="activeEmployeesGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function CompanyTypeSelect({companyId, setCompanyId, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        setCompanyId(selectedCompanyId);
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined && companyId.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [companyId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={companyId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((companyId) => ( 
                SetCompanyType(companyId)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}
function ClassificationIdSelect({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function DepartmentIdSelect({departmentId, setDepartmentId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDepartmentId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Department/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(departmentId !== "" && departmentId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [departmentId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={departmentId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose department</option>
            {data.map((departmentId) => ( 
                SetDepartmentId(departmentId)
            ))}
            </select>
        </div>
    );
};
function SetDepartmentId(departmentId){
    return(
        <option value={departmentId.id}>{
            departmentId.description}
        </option>
    )
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose location</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
export default Alphalist
